import { OrderStatusOption } from "@fitness-app/data-models/entities/Order";

export const tagColorMapper = {
  [OrderStatusOption.Created]: "#108ee9",
  [OrderStatusOption.Paid]: "#87d068",
  [OrderStatusOption.Finalized]: "#2db7f5",
  [OrderStatusOption.Imported]: "#2db7f5",
  [OrderStatusOption.Failed]: "#f64e60",
  [OrderStatusOption.Refunded]: "#f64e60",
  [OrderStatusOption.Scheduled]: "#ffc53d",
  // Szary, nie czerwony — anulowane zamówienie nie jest problemem do naprawy,
  // tylko zamkniętym wątkiem. Czerwień zostaje dla odmów i zwrotów (TRE-1999).
  [OrderStatusOption.Canceled]: "#8c8c8c",
};
